@let id = touristId();
@let v = view();
<div class="ins-row" [attr.data-testid]="'cabinet-insurance-row-' + id" [attr.data-state]="state()">
  <div class="ins-type" [attr.data-testid]="'cabinet-insurance-type-' + id">{{ 'Insurance policy' | translate }}</div>

  <div class="ins-desc" [attr.data-testid]="'cabinet-insurance-description-' + id">
    <div class="ins-who">
      @for (line of description(); track $index) {
        {{ line }}
      }
    </div>

    <span [class]="'ins-status tone-' + v.tone" [attr.data-testid]="'cabinet-insurance-status-' + id">{{
      v.status | translate
    }}</span>

    @if (state() === 'issued' || state() === 'operator') {
      @if (state() === 'operator') {
        <div class="ins-message" [attr.data-testid]="'cabinet-insurance-message-' + id">
          @if (issueDate(); as date) {
            <span [attr.data-testid]="'cabinet-insurance-issued-by-operator-' + id">{{
              'Your operator issued this policy on {date}. It is the same policy - no second one is created.'
                | translate: { date }
            }}</span>
          }
          @if (policyNumber(); as number) {
            <br />
            <span [attr.data-testid]="'cabinet-insurance-policy-number-' + id">
              @if (issueDate(); as date) {
                {{ 'Policy {number}, issued {date}' | translate: { number, date } }}
              } @else {
                {{ 'Insurance policy' | translate }} {{ number }}
              }
            </span>
          }
        </div>
      } @else if (policyNumber(); as number) {
        <div class="ins-message" [attr.data-testid]="'cabinet-insurance-message-' + id">
          <span [attr.data-testid]="'cabinet-insurance-policy-number-' + id">
            @if (issueDate(); as date) {
              {{ 'Policy {number}, issued {date}' | translate: { number, date } }}
            } @else {
              {{ 'Insurance policy' | translate }} {{ number }}
            }
          </span>
        </div>
      }
    }

    @if (v.message || v.nothingIssued) {
      <div class="ins-message" [attr.data-testid]="'cabinet-insurance-message-' + id">
        @if (state() === 'refused') {
          @if (reason(); as reason) {
            {{ 'The insurer did not accept the request: {reason}' | translate: { reason } }}<br />
          }
          {{
            'Nothing was issued and no money was taken. Check the tourist data and try again; if it repeats, quote the Trace ID to support.'
              | translate
          }}
        } @else if (v.message; as message) {
          {{ message | translate }}
        }
      </div>
    }

    @if (v.code; as code) {
      <div class="ins-code" [attr.data-testid]="'cabinet-insurance-code-' + id">{{ code }}</div>
    }

    @if (v.showTrace && traceId(); as trace) {
      <div class="ins-trace">
        <span>{{ 'Trace ID' | translate }}</span>
        <code [attr.data-testid]="'cabinet-insurance-trace-id-' + id">{{ trace }}</code>
        <button
          type="button"
          class="ins-trace-copy"
          [attr.data-testid]="'cabinet-insurance-trace-copy-button-' + id"
          [attr.aria-label]="'Copy Trace ID to clipboard' | translate"
          [attr.title]="'Copy Trace ID to clipboard' | translate"
          (click)="onCopyTrace()"
        >
          {{ (copied() ? 'Copied' : 'Copy') | translate }}
        </button>
      </div>
    }
  </div>

  <div class="ins-action">
    @switch (v.action) {
      @case ('create') {
        <button
          type="button"
          color="primary"
          mat-stroked-button
          class="ins-btn border-kz-primary! rounded-none! text-xs! tracking-normal!"
          [attr.data-testid]="'cabinet-insurance-create-button-' + id"
          (click)="onAct()"
        >
          {{ 'Create insurance' | translate }}
        </button>
      }
      @case ('busy') {
        <button
          type="button"
          color="primary"
          mat-stroked-button
          class="ins-btn border-kz-primary! rounded-none! text-xs! tracking-normal!"
          disabled
          [attr.data-testid]="'cabinet-insurance-create-button-' + id"
        >
          <span class="ins-spinner" [attr.data-testid]="'cabinet-insurance-spinner-' + id"></span>
          {{ 'Issuing...' | translate }}
        </button>
      }
      @case ('retry') {
        <button
          type="button"
          color="primary"
          mat-stroked-button
          class="ins-btn border-kz-primary! rounded-none! text-xs! tracking-normal!"
          [attr.data-testid]="'cabinet-insurance-retry-button-' + id"
          (click)="onRetry()"
        >
          {{ 'Try again' | translate }}
        </button>
      }
      @case ('download') {
        <button
          type="button"
          color="primary"
          mat-flat-button
          class="ins-btn rounded-none! text-xs! tracking-normal!"
          [disabled]="busy()"
          [attr.data-testid]="'cabinet-insurance-download-button-' + id"
          (click)="onAct()"
        >
          @if (busy()) {
            <span class="ins-spinner" [attr.data-testid]="'cabinet-insurance-spinner-' + id"></span>
          }
          {{ 'Download policy' | translate }}
        </button>
      }
    }
  </div>
</div>
